import React from 'react';

import Background from './../../assets/background.jpg';

interface State {

}

interface Props {

}


var footerStyle = {
    backgroundImage: `url(${Background})`,
    backgroundSize: 'cover'
}

export default class Footer extends React.Component<Props, State> {
    constructor(props){
        super(props);
        this.state = {}
    }

    render(){

        return(
            <div className="footer" >
           
           <div className="footer_inner_wrapper">
                 
             <div className="footer_col_left">
                <p>Cantura ist eine Marke der <br></br> <br></br> THANKYOUJANE GmbH</p>
             </div>
            

            <div className="footer_col_right">
            <p>Meichelbeckstr. 23 </p>
            <p>81545 München </p>
            <p>Deutschland</p>




            </div>
          
           </div>
            </div>
        )
    }
}